/**
 * Appointments / agenda service — adherence loop Fase 3.
 * Cookie-auth via axios withCredentials (set globally in config/api).
 */
import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const BASE = `${API_BASE_URL}/api/v1/appointments`;

const appointmentsService = {
  async upcoming(limit = 20) {
    const { data } = await axios.get(`${BASE}/upcoming`, { params: { limit } });
    return data;
  },

  async list({ start, end, patientUserId } = {}) {
    const params = {};
    if (start) params.start = start;
    if (end) params.end = end;
    if (patientUserId) params.patient_user_id = patientUserId;
    const { data } = await axios.get(BASE, { params });
    return data;
  },

  async create({ patientUserId, scheduledAt, durationMinutes = 30, type = 'consulta', notes = '', location = '' }) {
    const { data } = await axios.post(BASE, {
      patient_user_id: patientUserId,
      scheduled_at: scheduledAt,
      duration_minutes: durationMinutes,
      appointment_type: type,
      notes: notes || null,
      location: location || null,
    });
    return data;
  },

  async update(id, patch) {
    const { data } = await axios.patch(`${BASE}/${id}`, patch);
    return data;
  },

  async confirm(id) {
    return this.update(id, { status: 'confirmed' });
  },

  async cancel(id) {
    await axios.delete(`${BASE}/${id}`);
  },

  icsUrl(id) {
    return `${BASE}/${id}/ics`;
  },

  /** Google Calendar pre-filled "add event" link (no OAuth, no download). */
  googleCalendarUrl(appt) {
    const start = new Date(appt.scheduled_at.endsWith('Z') ? appt.scheduled_at : `${appt.scheduled_at}Z`);
    const end = new Date(start.getTime() + (appt.duration_minutes || 30) * 60000);
    const fmt = (d) => d.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
    const text = encodeURIComponent(`Cita de nutrición — ${appt.patient_name || 'Paciente'}`);
    const details = encodeURIComponent(appt.notes || 'Cita agendada en Nutrition Intelligence');
    const dates = `${fmt(start)}/${fmt(end)}`;
    const loc = appt.location ? `&location=${encodeURIComponent(appt.location)}` : '';
    return `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${text}&dates=${dates}&details=${details}${loc}`;
  },
};

export default appointmentsService;
